module.exports = __webpack_public_path__ + "play-60.4b3381a73d71c1e86a6ce57ada2ca35e.svg";